export const RouteKeys = {
  ALL: 'all',
  HOME: 'Home',
  ADMIN_USER: 'Admin User',
  ROLE: 'Role',
  USER: 'OTT User',
  SETTINGS: 'Settings',
  GENERAL: "General Setting",
  ONBOARDING_QUESTION_SETTINGS: "Onboarding Question Setting",
  PAYMENT_GATEWAY: "Payment Gateway",
  RESOURCE_SETTING: "Resource Setting",
  HELP_SUPPORT_SETTINGS: "Help Support Settings",
  AI_SETTINGS: "Ai Prompt Setting",
  PROMPT: 'Ai Prompt Setting',
  ONBOARDING: 'Onboarding Question',
  BOOKMARK_SETTINGS: "Bookmark Settings",
  PILLBANNER_SETTINGS: "PillBanner Settings",
  HTML_UPLOAD_SETTINGS: "Html Upload Settings",
  PLAN: 'Plan',
  PLAN_SET: 'PlanSet',
  ICONS: 'Icon',
  ICONS_LIST: 'Icon',
  MASTER: 'Master',
  LANGUAGE: 'Language Master',
  WIDGET: 'Widget Master',
  TOOLS: 'Tool Master',
  TEMPLATE_MASTER:'Template Master',
  APP_VERSION: 'App Version Master',
  TEMPLATE:'Template',
  CATEGORY:'Category',
  COLLECTION: 'Collection',
  SHOW: 'Show',
  EPISODE: 'Episode',
  ARTICLE: 'Article',
  REPORT: 'Report',
  DISLIKE_REPORT: 'Dislike Report',
  RATING_REPORT: 'Rating Report',
  SUBSCRIPTION_REPORT: 'Subscription Report',
  SUBSCRIPTION_HEALTH_REPORT: 'Subscription Health Report',
  USER_PLAN_REPORT: 'User Plan Report',
  PAYMENT_ORDER_REPORT: 'Payment Order Report',
  CONVERSION_FUNNEL_REPORT: 'Conversion Funnel Report',
  REVENUE_MONETIZATION_REPORT: 'Revenue Monetization Report',
  ACQUISITION_REPORT: 'Acquisition Report',
  ACQUISITION_FUNNEL_REPORT: 'Acquisition Report',
  LOGGER: 'Logger',
  VIDEO_TRACKING_LOGGER: 'Video Logger',
  BUFFER_LOGS: 'Video Buffer Logger',
  PLAYER_ERROR_LOGS: 'Video Error Logger',
  WEBHOOK_INSTRUMENT: 'Webhook Instrument Log',
  SEARCH_CAPSULES: 'Search Capsule',
  CACHE_PURGE: 'Cache Purge',
  PERSONALIZED_SIMULATION: 'Personalized Simulation',
  ACTIVITY_LOG: 'Activity Log',
  ERROR_LOG: 'Error Log',
  LOGIN_ACTIVITY: 'Login Activity',
  // WIDGET_ITEM_TYPE: 'widgetitemtype',
  // WIDGET_ITEM: 'widgetitem',
  // WIDGET_TYPE: 'widgettype',
  MONETIZATION: "Monetization",
  MONETIZATION_CONFIGURATION: "MonetizationConfiguration",
  // TABLEPLAN: "TabPlan",
  PAGES: 'Pages',

  RESOURCE: 'Resource',
  RESOURCE_TYPE: 'ResourceType',
  CONTEST: 'Contest',
  REWARDS: 'Rewards',
  QUESTIONS: 'Questions',
  TEMPLATE_TYPE: 'Template Master',
  // TABLEPLAN: 'Tableplan',
  PAYWALL: "Paywall",
  PAYWALL_TEMPLATE: 'PaywallTemplate',
  CONVERSION_REPORT: 'Conversion Report',
  ENGAGEMENT_REPORT: 'Engagement Report',
  MONETIZATION_REPORT: 'Monetization Report',
  USER_ACTIVITY_REPORT: 'User Activity Report',
  CONTENT_ANALYTICS_REPORT: 'Content Analytics Report',

  // Newly added keys
  CUSTOM_CHECKOUT: 'Payment Method',
  PAYMENT_ERROR: 'Payment Error',
};

export default RouteKeys
